<template>
    <div v-if="row !== null">
        <!-- <div v-if="column.field==='workMum'"> -->

        <span v-text-lbl="'signCode'" style="margin-right: 10px" :style="{ color: (row.exportStatus === '未开始' || row.exportStatus === '进行中') && row.openSgin === 1 && row.wfNodeNames === '已结束' && row.status !== 7 ? '#409efe' : '#909399', cursor: (row.exportStatus === '未开始' || row.exportStatus === '进行中') && row.openSgin === 1 && row.wfNodeNames === '已结束' && row.status !== 7 ? 'pointer' : 'default' }" @click=";(row.exportStatus === '未开始' || row.exportStatus === '进行中') && row.openSgin === 1 && row.wfNodeNames == '已结束' && row.status !== 7 ? initById(row) : ''">
            签到二维码
        </span>
        <template v-if="row.passenger.isLayout === 1">
            <span v-text-lbl="'personSeatSetting'" style="margin-right: 10px" :style="{ color: row.exportStatus === '未开始' && row.status !== 7 ? '#409efe' : '#909399', cursor: meetStatus === '未开始' && row.status !== 7 ? 'pointer' : 'default' }" @click="meetStatus === '未开始' && row.status !== 7 ? seatSet(row) : ''">人员坐席设置</span>
        </template>
        <span v-text-lbl="'change'" style="margin-right: 10px" :style="{ color: row.exportStatus === '未开始' && row.wfNodeNames === '已结束' && row.status !== 7 ? '#409efe' : '#909399', cursor: row.exportStatus === '未开始' && row.wfNodeNames === '已结束' && row.status !== 7 ? 'pointer' : 'default' }" @click="row.exportStatus === '未开始' && row.wfNodeNames === '已结束' && row.status !== 7 ? meetingchange(row) : ''">变更</span>
        <span v-if="row.status !== 7" v-pageBtn-lbl="'cancel'" :style="{ color: row.exportStatus === '未开始' && row.wfNodeNames === '已结束' && row.status !== 7 ? '#409efe' : '#909399', cursor: row.exportStatus === '未开始' && row.wfNodeNames === '已结束' && row.status !== 7 ? 'pointer' : 'default' }" @click="row.exportStatus === '未开始' && row.wfNodeNames === '已结束' && row.status !== 7 ? meetingcancelled(row) : ''">取消</span>
        <span v-if="row.status === 7" v-text-lbl="'isCancel'" :style="'color:#909399;cursor:default'">已取消</span>
        <!-- </div>
    <div v-if="column.field==='huiyizhuan'">
      <span>{{ transTime(row.startTime,row.endTime) }}</span>
    </div> -->
        <el-dialog :title="$tx('hygl.components.signCode', '签到二维码')" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" :before-close="handleClose">
            <div class="contQR">
                <h3>{{ row.flSubject }}</h3>
                <span v-text-lbl="'scanSignin'">扫描二维码签到</span>
                <img :src="imageUrl" alt="" />
                <p v-text-lbl="'meetingAddress'" style="text-align: left" :place="row.meetPlace">会议地点：{{ row.meetPlace }}</p>
                <p v-text-lbl="'meetingPerson'" style="text-align: left" :person="row.flCreator">召集人：{{ row.flCreator }}</p>
                <p v-text-lbl="'meetingPhone2'" style="text-align: left" :phone="row.flCreatorPhone">联系电话:{{ row.flCreatorPhone }}</p>
                <p v-text-lbl="'meetingTime3'" style="text-align: left;width: 400px;" :time="row.startTime + ' - ' + row.endTime">会议时间：{{ row.startTime + ' - ' + row.endTime }}</p>
            </div>
        </el-dialog>
        <el-dialog v-if="isShow" v-el-drag-dialog :title="$tx('hygl.components.meeingUpdate', '会议变更')" :visible.sync="isShow" :close-on-click-modal="false" width="1000px">
            <el-form ref="changeForm" :rules="rules" :model="replayVo" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td v-field-lbl="'flSubject'" class="el-table__cell tdlbl tdw17" colspan="1">会议主题</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ rows.flSubject }}</span>
                                    </td>
                                    <td v-text-lbl="'meetingAddress2'" class="el-table__cell tdlbl tdw17" colspan="1">会议地点</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <el-select v-model="value1" placeholder="请选择" style="width: 180px" @change="changeoptions6">
                                            <el-option v-for="item in options6" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </td>
                                </tr>
                                <tr>
                                    <td v-field-lbl="'startTime'" class="el-table__cell tdlbl tdw17" colspan="1">开始时间</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <el-date-picker v-model="rows.startTime" :step-num="5" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :placeholder="$tx('hygl.components.selectTime', '选择日期时间')" @change="startTimechange"></el-date-picker>
                                    </td>
                                    <td v-field-lbl="'endTime'" class="el-table__cell tdlbl tdw17" colspan="1">结束时间</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <el-date-picker v-model="rows.endTime" :step-num="5" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :placeholder="$tx('hygl.components.selectTime', '选择日期时间')" @change="endTimechange"></el-date-picker>
                                    </td>
                                </tr>
                                <tr>
                                    <td v-field-lbl="'flCreateDept'" class="el-table__cell tdlbl tdw17" colspan="1">召集部门</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ rows.flCreateDept }}</span>
                                    </td>
                                    <td v-field-lbl="'flCreator'" class="el-table__cell tdlbl tdw17" colspan="1">召集人</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ rows.flCreator }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td v-text-lbl="'phone'" class="el-table__cell tdlbl tdw17" colspan="1">联系电话</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ rows.flCreatorPhone }}</span>
                                    </td>
                                    <td v-field-lbl="'meetHost'" class="el-table__cell tdlbl tdw17" colspan="1">会议主持人</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ rows.meetHost }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td v-field-lbl="'attendLeader'" class="el-table__cell tdlbl tdw17" colspan="1">出席领导</td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <span>{{ rows.attendLeader }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_会议主题" v-field-lbl="'flContent'" class="el-table__cell tdlbl tdw17" colspan="1">会议内容</td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <span>{{ rows.flContent }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_会议主题" v-field-lbl="'meetingAttach'" class="el-table__cell tdlbl tdw17" colspan="1">会议附件</td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <div v-for="item in attachs" :key="item">
                                            <span class="hoverSpan" style="cursor: pointer" @click="downloadFuc(item.id)">{{ item.fileName }}</span>
                                        </div>
                                    </td>
                                </tr>
                                <!-- <tr  key="radio">
                  <td class="el-table__cell tdlbl tdw17"><span class="required">*</span>承办人</td>
                  <td class="el-table__cell tdcont tdw83" colspan="5">
                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="承办人" rules="required">
                      <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                        <el-input
                          v-model="replayVo.recUser"
                          v-select-dialog="'staff'"
                          type="input"
                          multiple="false"
                          :root-org-code="loginUser.orgCode"
                          name="recUser"
                          placeholder="请选择承办人"
                          :org-id="row.orgFullId.split('-')[1]"
                        >
                        </el-input>
                      </el-tooltip>
                    </ValidationProvider>
                  </td>
                </tr> -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <!-- <button v-show="anniu" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" :icon="'el-icon-close'" :disabled="doing" @click="close">关 闭</el-button>
                <el-button v-pageBtn-lbl="'sure'" type="primary" :disabled="doing" :icon="'el-icon-check'" @click="SignforConfirm">确 定</el-button>
            </span>
        </el-dialog>
        <!-- <meetingchange v-if="isShow" ref="meetingchange" :crow="rows" @cancleRule="cancleRule"></meetingchange> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import meetingchange from './components/meetingchange'
const moment = require('moment')
export default {
    components: {
        // meetingchange
    },
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        },
        index: {
            type: String,
            default: function () {
                return '0'
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            meetStatus: '',
            imageUrl: '',
            isShow: false,
            rows: {},
            replayVo: {},
            options6: [],
            attachs: null,
            value1: '',
            listdata: [],
            stTime: '', // 选择会议地点储存会议开放开始时间
            enTime: ''
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        // debugger
        const dateNow = new Date().valueOf()
        const startTime = this.functiontransdate(this.row.startTime)
        const endTime = this.functiontransdate(this.row.endTime)

        if (startTime > dateNow) {
            this.meetStatus = '未开始'
        } else if (endTime < dateNow) {
            this.meetStatus = '已结束'
        } else if (startTime < dateNow) {
            this.meetStatus = '进行中'
        }
    },
    methods: {
        // 日期转时间戳
        functiontransdate(endTime) {
            var date = new Date()
            date.setFullYear(endTime.substring(0, 4))
            date.setMonth(endTime.substring(5, 7) - 1)
            date.setDate(endTime.substring(8, 10))
            date.setHours(endTime.substring(11, 13))
            date.setMinutes(endTime.substring(14, 16))
            date.setSeconds(endTime.substring(17, 19))
            return Date.parse(date)
        },
        transTime(start, end) {
            var date = new Date()

            var startTime = new Date(start)
            var endTime = new Date(end)
            if (startTime > date) {
                return '未开始'
            } else if (endTime < date) {
                return '已结束'
            } else if (startTime < date) {
                return '进行中'
            }
        },

        // 获取二维码
        async initById(row) {
            // if (row.openSgin === 1 && this.meetStatus === '未开始') {
            this.dialogVisible = true
            await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/base/paramConfig/findParamValueByName',
                params: {
                    orgCode: this.loginUser.orgCode,
                    paramName: 'mpp.h5app.baseurl'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    var urlStr = res.body.value + '#/QRwaiting?apigateway=' + location.host + '&meetId=' + row.id + ''
                    urlStr = encodeURI(urlStr)
                    console.log('urlStr', urlStr)
                    const _this = this
                    this.$http({
                        method: 'GET',
                        contentType: 'application/x-www-form-urlencoded',
                        url: '/hygl/hyap/getQrCode',
                        params: {
                            url: urlStr
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            _this.dialogVisible = true
                            this.imageUrl = 'data:image/png;base64,' + res.body.image
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
                } else {
                    this.$message.error(this.$tx('hygl.message.noFindH5', '未检测到h5参数！请联系管理员'))
                }
            })

            // }
        },
        // 人员坐席设置
        seatSet(row) {
            // row.id 当前行数据id
            // row.meetingId 会议室id
            window.open('#/seatSelect?rowId=' + row.id + '&meetingId=' + row.meetingId)
        },
        // 变更
        meetingchange(row) {
            row.startTime = row.startTime.substr(0, 16)
            row.endTime = row.endTime.substr(0, 16)
            this.value1 = row.meetPlace
            this.isShow = true
            this.rows = { ...row }
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    busiDataIds: row.id
                },
                url: `/hygl/attach/queryAttachList?urlsearch=orgCode:${this.loginUser.orgCode}`
            }).then((result) => {
                if (result.code === 'success') {
                    this.attachs = result.body.listdata
                    console.log(this.attachs)
                } else {
                    this.$message.error(result.message)
                }
            })
            var arr = []
            this.$http({
                method: 'POST',
                url: 'hygl/meetingRoom/querydata',
                data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                params: { orderBy: 'meetName asc' }
            }).then((res) => {
                if (res.code === 'success') {
                    this.listdata = res.body.listdata
                    for (let i = 0; i < res.body.listdata.length; i++) {
                        arr.push({ label: res.body.listdata[i].meetName, value: res.body.listdata[i].id })
                        if (this.listdata[i].meetName === row.meetPlace) {
                            this.stTime = this.listdata[i].beginTime // 选择会议地点储存会议开放开始时间
                            this.enTime = this.listdata[i].endTime
                        }
                    }
                    this.options6 = arr
                }
            })
            console.log('点击', row)
        },
        close() {
            this.isShow = false
        },
        SignforConfirm() {
            console.log('确定', this.rows)
            var stTime = moment(this.rows.startTime).format('YYYY-MM-DD HH:mm')
            var endTime = moment(this.rows.endTime).format('YYYY-MM-DD HH:mm')
            var stTime1 = moment(this.rows.startTime).format('YYYY-MM-DD') + ' ' + this.stTime.substr(11, 5)
            var enTime1 = moment(this.rows.endTime).format('YYYY-MM-DD') + ' ' + this.enTime.substr(11, 5)
            stTime = new Date(stTime).getTime()
            stTime1 = new Date(stTime1).getTime()
            endTime = new Date(endTime).getTime()
            enTime1 = new Date(enTime1).getTime()
            if (new Date(this.rows.startTime).getTime() < new Date(moment(new Date()).format('YYYY-MM-DD HH:mm')).getTime()) {
                this.$alert(this.$tx('hygl.message.meetingLater', '会议室开始时间不得晚于当前时间'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            // debugger
            if (this.rows.startTime > this.rows.endTime) {
                this.$alert(this.$tx('hygl.message.meetingBegin', 'meetingBegin'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            if (stTime < stTime1 || stTime > endTime || endTime > enTime1) {
                this.$alert(this.$tx('hygl.message.meetingBeginTo', '会议室开放时间为') + this.stTime.substr(11, 5) + ' - ' + this.enTime.substr(11, 5), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            this.rows.status = 2
            this.$http({
                method: 'put',
                url: '/hygl/hyap/updateHyap',
                data: this.rows
            }).then((res) => {
                if (res.code === 'success') {
                    this.rows = {}
                    this.isShow = false
                    this.$bus.emit('refreshListData')
                    this.$message.success(res.message)
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        meetingcancelled(row) {
            console.log('取消')
            this.$confirm(this.$tx('hygl.message.isCancelMeet', '确定取消此次会议吗？'), this.$tx('common.confirm', '确认操作'), { type: 'warning' }).then(
                () => {
                    row.status = 7
                    this.$http({
                        method: 'put',
                        url: '/hygl/hyap/updateHyap',
                        data: row
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$bus.emit('refreshListData')
                            this.$message.success(this.$tx('hygl.message.meetingCancel', '会议取消成功'))
                        } else {
                            this.$message.error(this.$tx('hygl.message.meetingCancelFail', '会议取消失败'))
                        }
                    })
                },
                () => {}
            )
        },
        // 下载会议题件
        downloadFuc(id, num) {
            var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + id + '&httpPort=' + location.port
            window.open(attachurl, '_blank')
        },
        // 开始时间改变
        startTimechange(val) {
            console.log('开始时间改变', val)
            this.rows.startTime = val
        },
        // 结束时间改变
        endTimechange(val) {
            console.log('结束时间改变', val)
            this.rows.endTime = val
        },
        // 地点改变
        changeoptions6(val) {
            console.log('地点改变', val)
            for (let i = 0; i < this.listdata.length; i++) {
                if (this.listdata[i].id === val) {
                    this.rows.meetPlace = this.listdata[i].meetName
                    this.stTime = this.listdata[i].beginTime // 选择会议地点储存会议开放开始时间
                    this.enTime = this.listdata[i].endTime // 选择会议地点储存会议开放开始时间
                    //        _this.vo.numPeople=_this.listdatamc6[i].numPeople
                    //         _this.vo.serviceProperties=_this.listdatamc6[i].serviceProperties
                    //         _this.vo.deviceProperties=_this.listdatamc6[i].deviceProperties
                    //         _this.vo.meetName=_this.listdatamc6[i].meetName
                    //        _this.vo.weekProperties=_this.listdatamc6[i].weekProperties
                    //     _this.checkListss1=_this.listdatamc6[i].weekProperties.split(',')
                    //      _this.checkList=_this.listdatamc6[i].weekProperties.split(',')
                    //      _this.stTime=_this.listdatamc6[i].beginTime
                    //        _this.endTime=_this.listdatamc6[i].endTime
                    //     _this.selectableRange=_this.listdatamc6[i].beginTime.substr(11,5)+'-'+_this.listdatamc6[i].endTime.substr(11,5)
                    //      _this.vo.remark=_this.listdatamc6[i].remark
                    //    _this.vo.meetName=_this.listdatamc6[i].meetName
                    //      _this.$set(_this.vo, 'meetRoomId',_this.listdatamc6[i].id)
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
/deep/.el-table__body-wrapper.is-scrolling-none {
    height: 310px;
    overflow: hidden;
    overflow-y: auto;
}
/deep/.el-table .el-textarea__inner {
    height: 36px;
}
.contQR {
    width: 400px;
    height: 500px;
    margin: 0 auto;
    h3,
    h4 {
        margin: 0;
    }
    img {
        width: 340px;
        height: 340px;
        margin: 0 auto;
    }
    p {
        margin: 0;
        padding: 0 40px;
    }
}
</style>
